/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Dataroom_Replacefiles_Replace3Inputs */

const en_coinvestments_dataroom_replacefiles_replace3 = /** @type {(inputs: Coinvestments_Dataroom_Replacefiles_Replace3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Replace`)
};

/**
* | output |
* | --- |
* | "Replace" |
*
* @param {Coinvestments_Dataroom_Replacefiles_Replace3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_dataroom_replacefiles_replace3 = /** @type {((inputs?: Coinvestments_Dataroom_Replacefiles_Replace3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Dataroom_Replacefiles_Replace3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_dataroom_replacefiles_replace3(inputs)
});
export { coinvestments_dataroom_replacefiles_replace3 as "coInvestments_dataRoom_replaceFiles_replace" }